/// <amd-module name="TFS/NetPromoterSurvey/Common" />

export interface IResponse {
    score?: number;
    reason?: string;
    role?: string;
    contactConsented?: boolean;
}

export enum DataKeys {
    AnonymousAccess = "AnonymousAccess",
    ContactMe = "OkToContactMe",
    DeferredTimes = "DeferredTimes",
    ExitMethod = "ExitMethod",
    FeatureAvailability = "FeatureAvailability",
    HubGroupId = "HubGroupId",
    HubId = "HubId",
    Interaction = "Interaction",
    InteractionType = "InteractionType",
    MaxAllowableDeferTimes = "MaxAllowableDeferTimes",
    Navigation = "Navigation",
    NPSDebugCookieEnabled = "NPSDebugCookieEnabled",
    OperationDate = "OperationDate",
    ProductName = "ProductName",
    PromptId = "PromptId",
    Reason = "Reason",
    Response = "Response",
    Score = "Score",
    SurveyId = "SurveyId",
    Url = "Url",
    UserRole = "UserRole",
    VerticalNavigationEnabled = "VerticalNavigationEnabled"
}
